import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { map, Observable } from 'rxjs';

import { MeasurementUnit, MeasurementUnitEntity } from '../models/devices';

@Injectable({ providedIn: 'root' })
export class MeasurementUnitsService {
  private http = inject(HttpClient);

  getUnitList(): Observable<MeasurementUnitEntity[]> {
    return this.http
      .get<{ data: MeasurementUnitEntity[] }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/measurement-units`)
      .pipe(map((response) => response.data));
  }

  createNewUnit(unit: MeasurementUnit): Observable<MeasurementUnitEntity> {
    return this.http
      .post<{ data: MeasurementUnitEntity }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/measurement-units`, unit)
      .pipe(map((response) => response.data));
  }

  updateUnit(unit: MeasurementUnit): Observable<MeasurementUnitEntity> {
    return this.http
      .patch<{ data: MeasurementUnitEntity }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/measurement-units/${unit.id}`, unit)
      .pipe(map((response) => response.data));
  }

  deleteUnit(unitId: string): Observable<void> {
    return this.http.delete<void>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/measurement-units/${unitId}`);
  }
}
